import React, { forwardRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  id: string;
  defaultText?: string;
  multiple?: boolean;
  name?: string;
  accept?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const FileInput = forwardRef<HTMLInputElement, Props>((props , ref) => {
  // translations
  const translations = useTranslation("shared\\components");
  
  // destruct
  const {id, defaultText, multiple, name, accept, onChange } = props;

  // state
  const [selectedFilesText, setSelectedFilesText] = useState("");

  // handlers
  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = e.target.files;
    
    if (selectedFiles && selectedFiles.length > 0) {
      let text = getText(selectedFiles);
      setSelectedFilesText(text);
    } else {
      setSelectedFilesText("");
    }

    if (onChange) {
      onChange(e);
    }
  }

  const getText = (selectedFiles: FileList) => {
    if (selectedFiles.length == 1) {
      return selectedFiles[0].name;
    } else {
      return `${translations.t("fileInput.selectedFiles")} ${selectedFiles.length}`;
    }   
  }

  // render
  return (
    <div className="custom-file">
      <input ref={ref} type="file" className="custom-file-input" lang={translations.i18n.language} id={id} name={name} multiple={multiple} accept={accept} onChange={onChangeHandler}/>
      <label className="custom-file-label text-truncate" htmlFor={id}>
          {selectedFilesText ? selectedFilesText : (defaultText ?? translations.t("fileInput.selectFile"))}
      </label>
    </div>
  )
})

export default FileInput;
